module.exports = __webpack_public_path__ + "img/1597687910.029a9253.jpg";